import React from 'react';
import { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from 'src/shared/components/ui/tooltip';

type ExplainedIconProps = {
    message: string;
    className: string;
    testId?: string;
    children: React.ReactNode;
};

/**
 * An icon that explains itself on hover. The `aria-label` repeats the tooltip
 * text so the explanation reaches a screen reader rather than only a mouse.
 */
const ExplainedIcon = ({ message, className, testId, children }: ExplainedIconProps) => (
    <TooltipProvider delayDuration={200}>
        <Tooltip>
            <TooltipTrigger asChild>
                <span tabIndex={0} role='img' aria-label={message} data-testid={testId} className={`inline-flex shrink-0 ${className}`}>
                    {children}
                </span>
            </TooltipTrigger>
            <TooltipPortal>
                <TooltipContent side='left'>{message}</TooltipContent>
            </TooltipPortal>
        </Tooltip>
    </TooltipProvider>
);

export default ExplainedIcon;
